import { afterNextRender, ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { VideoPlayerComponent } from '../../media/video-player/video-player.component';
import { PresentationController } from '../../presentation-controller';
import { SlideLayoutConfigService } from '../../slide-layout-config.service';
import { SlideTextComponent } from '../../slide-text/slide-text.component';
import { TextOverflowDirective } from '../../text-overflow.directive';

@Component({
  selector: 'ds-split-layout',
  imports: [SlideTextComponent, VideoPlayerComponent, TextOverflowDirective],
  templateUrl: './split-layout.component.html',
  styleUrls: ['./split-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplitLayoutComponent {
  private readonly config = inject(SlideLayoutConfigService);

  public readonly controller = input.required<PresentationController>();
  public readonly slide = computed(() => this.controller().slide);
  public readonly content = computed(() => this.slide().content);
  public readonly fullscreen = computed(() => this.slide().hasFullscreenContent === true);
  public readonly image = computed(() => this.controller().image());
  public readonly closedCaptions = this.config.closedCaptions;

  public constructor() {
    afterNextRender(() => this.startCarousel());
  }

  private startCarousel(): void {
    const controller = this.controller();
    const slide = controller.slide;
    const images = slide.images ?? slide.content.images ?? [];

    if (slide.content.showVideo || images.length === 0) {
      return;
    }

    const shown = this.fullscreen() ? images.slice(0, 1) : images;
    controller.wait(controller.carousel(shown, slide.carouselSecondsPerImage ?? this.config.carouselSeconds()));
  }
}
